export default __webpack_public_path__ + "static/media/ChartMogul.1cdc52ef.webp";